export default (payload) => ({
  type: 'UPDATE_LEAD_STATE',
  payload,
});
